import {
  ModalType,
  useFeatureFlagContext,
  useModalContext,
} from 'modules/campaigns/editor/context';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { TimeClock24 } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const ScheduleDisplayCampaignAction = () => {
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { openModal } = useModalContext();

  return (
    <CampaignPermissionCheck action={'schedule'} ChildWrapper={CampaignPopover}>
      <PrimaryButton
        data-test="schedule-display-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.DisplayEligibilityCampaign)}
        isDisabled={isSuspendSendsEnabled}
      >
        <TimeClock24 />
        Schedule
      </PrimaryButton>
    </CampaignPermissionCheck>
  );
};
